import { createStore } from "state-pool";
import { APP_CFG, DOMAIN_CFG } from "./constants";
import { defaultAppCfg, defaultDomainCfg, DomainConfiguration } from "./types";
import { getAppInstance } from "../appContext";

export const storeMap = {};
export let store;

export const createAppStore = (instanceId) => {
  console.log('App:'+instanceId+ ' create store');
  const newStore = createStore();
  storeMap[instanceId] = newStore;
  store = newStore;
  store.setState(APP_CFG, defaultAppCfg);
}

export const switchAppStore = (instanceId) => {
  console.log('App:'+instanceId+ ' has now active store');
  store = storeMap[instanceId];
}

export const getAppStore = () => {
  const instanceId = getAppInstance();
  return storeMap[instanceId];
}

export const getStateValue = (key : string) : any => {
  return { ...getAppStore().getState(key).getValue() };
}

export const getStateValueFromInstance = (key : string, instanceId : string) : any => {
  const appStore = storeMap[instanceId];
  //console.log('getStateValueFromInstance', key, instanceId, appStore);
  return { ...appStore.getState(key).getValue() };
}

export const setStateValue = (key : string, value : any) : void => {
  const state = getAppStore().getState(key);
  state.updateValue((data) => {
    return { ...value }
  } );
}

export const setStateValueForInstance = (key : string, value : any, instanceId : string) : void => {
  const state = storeMap[instanceId].getState(key);
  state.updateValue((data) => {
    return { ...value }
  } );
}

export const getStateVariable = (key : string) : any => {  
  return getAppStore().getState(key).getValue();
}

export const setStateVariable = (key : string, value : any) : void => {
  const state = getAppStore().getState(key);
  state.updateValue((data) => {
    return value
  } );
}

export function getDomainCfg() : DomainConfiguration {
  const domainCfg = getStateValue(DOMAIN_CFG);
  if (domainCfg && domainCfg.initialized === true) {
    return domainCfg;
  }
  return defaultDomainCfg;
}

export function setDomainCfg(newDomainCfg : DomainConfiguration) : void {
  const domainCfg = getStateValue(DOMAIN_CFG);
  if (domainCfg.initialized === true) {
    return setStateValue(DOMAIN_CFG, newDomainCfg);
  }
}
